<template>
  <v-form>
    <TextInput
      v-model="formData.user_group_name"
      :field-key="fieldKey('user_group_name')"
      :label="$t('UserGroup.UserGroupName')"
      required
    />

    <SelectItem
      v-model="formData.parent"
      :field-key="fieldKey('parent')"
      :label="$t('UserGroup.ParentGroup')"
      :items="selectGroupList"
      item-title="user_group_name"
      item-value="id"
    />
    <div
      v-if="!formData.parent"
      style="margin-top: -20px;"
      class="caption text-grey-darken-2 ml-2"
    >
      {{ $t('UserGroup.FormInfo.NoSelectParentIsTop') }}
    </div>
  </v-form>
</template>

<script>
  import TextInput from '@/components/parts/inputs/TextInput'
  import FormMixin from './FormMixin'
  import SelectItem from '@/components/parts/inputs/SelectItem'

  export default {
    components: {
      SelectItem,
      TextInput
    },
    mixins: [FormMixin],
    props: {
      createFromParent: {
        type: Number,
        default: null
      }
    },
    data: () => ({
      formData: {
        id: null,
        user_group_name: '',
        parent: null
      },
      selectGroupList: []
    }),
    watch: {
      createFromParent () {
        this.formData = {
          id: null,
          user_group_name: '',
          parent: this.createFromParent
        }
      }
    },
    created () {
      this.$http.get('user-groups/', { params: { limit: 1000 } }).then((res) => {
        this.selectGroupList = res.data.results
        this.selectGroupList.unshift({ id: null, user_group_name: '------' })
      })
      this.applyCurrentData()
    }
  }
</script>
